import { useEffect, useState } from 'react'
import { anonLocalStorageIdentifierKey, getUUID } from '../../utility'

const useGetUserIdentifier = (): string | null => {
  const [identifier, setIdentifier] = useState<string>(null)

  useEffect(() => {
    if (!identifier) {
      let storedIdentifier = null
      try {
        storedIdentifier = localStorage.getItem(anonLocalStorageIdentifierKey)
      } catch (e) {
        console.log(e)
      }
      if (storedIdentifier) {
        setIdentifier(storedIdentifier)
      } else {
        const newIdentifier = getUUID()
        try {
          localStorage.setItem(anonLocalStorageIdentifierKey, newIdentifier)
        } catch (e) {
          console.log(e)
        }
        setIdentifier(newIdentifier)
      }
    }
  }, [identifier])

  return identifier
}

export default useGetUserIdentifier
